'use client';
import React from 'react';
import { formatText } from '@/utils/text/text';

export const TYPE_HEADING = {
    H1: 'heading1',
    H2: 'heading2',
    H3: 'heading3',
    H4: 'heading4',
    H5: 'heading5',
    H6: 'heading6'
} as const;

export type HeadingValue = (typeof TYPE_HEADING)[keyof typeof TYPE_HEADING];

// Type mapping from heading name to corresponding JSX tag
const TYPE_HEADING_TYPE = {
    heading1: 'h1',
    heading2: 'h2',
    heading3: 'h3',
    heading4: 'h4',
    heading5: 'h5',
    heading6: 'h6'
} as const;

export type RichTextHeadingProps = {
    type: HeadingValue;
    className?: string;
    text: string;
    currencySymbol?: string;
};

export const RichTextHeading: React.FC<RichTextHeadingProps> = ({ type, className, ...props }) => {
    const Element = TYPE_HEADING_TYPE[type];
    // TODO: remove dangerouslySetInnerHTML
    return Element ? <Element className={className} dangerouslySetInnerHTML={{ __html: formatText(props) }} /> : null;
};
